import { render } from "./UsersEditing.vue?vue&type=template&id=6ab85579"
import script from "./UsersEditing.vue?vue&type=script&lang=js"
export * from "./UsersEditing.vue?vue&type=script&lang=js"
script.render = render

export default script